import { coreColors } from '../../../../../styles/shared/variables';

export const desktopHeaderDropdownStyle = {
    width: '500px',
    textAlign: 'center'
}

export const desktopHeaderDropdownMenuItemStyle = {
    fontSize: '32px',
    color: coreColors.blue300
}


// WEBPACK FOOTER //
// ./src/components/common/dropdowns/header/styles/desktop.js